'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:inject:close');
}

var _invoke = require('../invoke');

/**
 * 关闭隐藏 webview
 *
 * 主要为了减小内存占用
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof inject
 * @static
 * @name close
 * @param {String} name 隐藏 webview 名
 * @return {Promise}
 * @example
 *  hbnb.inject.close('name')
 */
module.exports = function(name) {
    if (process.env.NODE_ENV !== 'production') {
        debug('name is %s', name);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('inject', 'close', {
            name: name,
            callback: function() {
                resolve();
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/inject/close.js
// module id = 589
// module chunks = 0